// extracted by mini-css-extract-plugin
export default {"container":"_55a043d1","isFullWidth":"_b7fe6c59","content":"_1404379f","iconWrapper":"_bd449b8e","icon":"_18427dfd"};